import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

export type AutopayEnrollmentBannerVariant = 'domestic' | 'sepa';

@Component({
  selector: 'autopay-enrollment-banner',
  templateUrl: './autopay-enrollment-banner.component.html',
  styleUrls: ['./autopay-enrollment-banner.component.scss'],
})
export class AutopayEnrollmentBannerComponent implements OnInit {
  @Input() variant: AutopayEnrollmentBannerVariant = 'domestic';
  @Output() enrollClicked = new EventEmitter<void>();

  headingKey: string;

  bodyKey: string;

  ngOnInit(): void {
    this.headingKey =
      this.variant === 'sepa'
        ? 'ARC_PAYMENT_AUTOPAY_ENROLLMENT_BANNER_SEPA_HEADING'
        : 'ARC_PAYMENT_AUTOPAY_ENROLLMENT_BANNER_DOMESTIC_HEADING';
    this.bodyKey =
      this.variant === 'sepa'
        ? 'ARC_PAYMENT_AUTOPAY_ENROLLMENT_BANNER_SEPA_BODY'
        : 'ARC_PAYMENT_AUTOPAY_ENROLLMENT_BANNER_DOMESTIC_BODY';
  }
}
